import Head from 'next/head';
import Link from 'next/link';

export default function AboutUs() {
  return (
    <>
      <Head>
        <title>About us | York Round Table | #DoMore</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <div className="mx-auto w-full max-w-screen-xl">
        <article className="mx-auto w-full max-w-screen-lg">
          <h1 className="text-4xl text-rt-orange text-center mb-10">About us</h1>
          <div className="mx-auto w-full max-w-screen-md text-white">
            <p className="mb-4 text-2xl">
              Round Table gives 18-45-year-old men the chance to experience new things, make new
              friends, gain new experiences, and make a difference in the local community.
            </p>

            <p className="mb-4">
              We get together every month to do everything from paintballing, go-karting, brewery
              visits or something as simple as a drink at the pub followed by a curry.
            </p>

            <p className="mb-4">
              Over the years we&apos;ve also run a number of charitable events to raise money for
              local good causes, including an annual quiz and curry night, beer festival and
              Christmas tree collections.
            </p>

            <p className="mb-8">
              If this sounds like something that interests you and you want to get to know new
              people in and around York, get in touch and join us at our next get together.
            </p>

            <p>
              <Link href="https://roundtable.co.uk/about-us/">
                <a className="inline-flex items-center justify-center px-6 py-2 border border-rt-orange text-white rounded-full">
                  Read more about the Round Table
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-2 h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1}
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    />
                  </svg>
                </a>
              </Link>
            </p>
          </div>
        </article>
      </div>
    </>
  );
}
